import { CheckCircle2 } from 'lucide-react';

interface WomensProgressBarProps {
  currentStep: number;
  totalSteps: number;
  stepTitles: string[];
}

export default function WomensProgressBar({ currentStep, totalSteps, stepTitles }: WomensProgressBarProps) {
  const progress = (currentStep / totalSteps) * 100;

  return (
    <div className="space-y-4">
      {/* Progress Bar */}
      <div className="relative">
        <div 
          className="h-2 rounded-full overflow-hidden"
          style={{ background: 'rgba(255, 255, 255, 0.05)' }}
        >
          <div
            className="h-full rounded-full transition-all duration-500 ease-out"
            style={{
              width: `${progress}%`,
              background: 'linear-gradient(90deg, #2FFFC7, #3B82F6)',
              boxShadow: '0 0 20px rgba(47, 255, 199, 0.5)',
            }}
          />
        </div>
      </div>

      {/* Step Indicators */}
      <div className="flex justify-between items-center">
        {stepTitles.map((title, index) => {
          const stepNumber = index + 1;
          const isActive = stepNumber === currentStep;
          const isCompleted = stepNumber < currentStep;
          
          return (
            <div 
              key={stepNumber}
              className="flex flex-col items-center"
              style={{ flex: 1 }}
            >
              <div
                className="w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium mb-2 transition-all"
                style={{
                  background: isCompleted || isActive
                    ? 'linear-gradient(90deg, #2FFFC7, #3B82F6)'
                    : 'rgba(255, 255, 255, 0.05)',
                  color: isCompleted || isActive ? '#000000' : '#9DA9B8',
                  boxShadow: isActive ? '0 0 20px rgba(47, 255, 199, 0.5)' : 'none',
                }}
              >
                {isCompleted ? <CheckCircle2 className="h-4 w-4" /> : stepNumber}
              </div>
              <span 
                className="text-xs text-center hidden md:block"
                style={{ 
                  color: isActive ? '#2FFFC7' : '#9DA9B8',
                  fontWeight: isActive ? 500 : 400,
                }}
              >
                {title}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
